'use client'

import { useContext } from 'react'

import { Button, Divider, Navigation } from '@vinted/web-ui'
import { ArrowLeft24, X24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'

import {
  isReturnShipment,
  isOldDropOffPointTypeFlow,
  isReusablePackagingFlowEnabled,
  isDigitalLabelFlowEnabled,
  isDropOffTypeFlow,
} from '../../../../utils/generate-label'

type Props = {
  handlePreviousClick: () => void
  handleModalClose: () => void
}

const DialogNavigation = ({ handleModalClose, handlePreviousClick }: Props) => {
  const translate = useTranslate('common.a11y.actions')
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
    },
  } = useContext(GetShippingLabelContext)

  const renderNavigationBackArrow = () => {
    const showBackButton =
      isReturnShipment(labelOptionsRewrite) ||
      isDigitalLabelFlowEnabled(labelOptions, labelOptionsRewrite) ||
      isOldDropOffPointTypeFlow(labelOptions) ||
      isReusablePackagingFlowEnabled(labelOptionsRewrite) ||
      isDropOffTypeFlow(labelOptionsRewrite, labelOptions)

    if (showBackButton)
      return (
        <Button
          styling="flat"
          iconName={ArrowLeft24}
          inline
          onClick={handlePreviousClick}
          testId="generate-label-modal-previous"
          aria={{ 'aria-label': translate('back') }}
        />
      )

    return null
  }

  return (
    <>
      <Navigation
        body={labelOptions?.screenTitle}
        left={renderNavigationBackArrow()}
        right={
          <Button
            styling="flat"
            onClick={handleModalClose}
            iconName={X24}
            inline
            testId="generate-label-modal-close"
            aria={{ 'aria-label': translate('dialog_close') }}
          />
        }
      />
      <Divider />
    </>
  )
}

export default DialogNavigation
